// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5432":"cda9084aedb9069d","9011":"5426bc6998105f4e"}[chunkId] + ".js";
};